import { fetchWithAuth } from "./fetchWithAuth";

const API_BASE = process.env.REACT_APP_API_BASE;

const unauthorizedError = new Error("Неовластен пристап.");

const handleJsonResponse = async (response, fallbackMessage) => {
  if (!response) {
    throw unauthorizedError;
  }

  if (!response.ok) {
    const text = await response.text();
    const detail = text || fallbackMessage;
    throw new Error(detail);
  }

  return response.status === 204 ? null : response.json();
};

export async function getInvitationTemplates() {
  const response = await fetch(`${API_BASE}/templates`, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });

  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || "Неуспешно вчитување на шаблони.");
  }

  return response.json();
}

export async function getUserInvitations() {
  const response = await fetchWithAuth(`${API_BASE}/user/invitations`, {
    method: "GET",
  });
  return handleJsonResponse(response, "Неуспешно вчитување на покани.");
}

export async function createInvitation(payload) {
  const response = await fetchWithAuth(`${API_BASE}/invitations`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
  return handleJsonResponse(response, "Неуспешно креирање на покана.");
}

export async function getUserInvitation(invitationId) {
  const response = await fetchWithAuth(
    `${API_BASE}/user/invitations/${invitationId}`,
    {
      method: "GET",
    }
  );
  return handleJsonResponse(response, "Поканата не беше пронајдена.");
}

export async function updateInvitation(invitationId, payload) {
  const response = await fetchWithAuth(
    `${API_BASE}/user/invitations/${invitationId}`,
    {
      method: "PUT",
      body: JSON.stringify(payload),
    }
  );
  return handleJsonResponse(response, "Неуспешно ажурирање на поканата.");
}

export async function uploadInvitationCover(invitationId, file) {
  if (!invitationId || !file) {
    throw new Error("Недостасува покана или датотека за прикачување.");
  }
  const formData = new FormData();
  formData.append("file", file);
  const response = await fetchWithAuth(
    `${API_BASE}/user/invitations/${invitationId}/cover`,
    {
      method: "POST",
      body: formData,
    }
  );
  return handleJsonResponse(response, "Неуспешно прикачување на насловна фотографија.");
}

export async function getInvitationBySlug(slug) {
  const response = await fetch(`${API_BASE}/invitations/${slug}`, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });

  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || "Поканата не беше пронајдена.");
  }

  return response.json();
}

export async function submitInvitationRSVP(slug, payload) {
  const response = await fetch(`${API_BASE}/invitations/${slug}/rsvp`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || "Неуспешно испраќање на RSVP.");
  }

  return response.json();
}

export async function getInvitationStats(invitationId) {
  const response = await fetchWithAuth(
    `${API_BASE}/user/invitations/${invitationId}/stats`,
    {
      method: "GET",
    }
  );
  return handleJsonResponse(response, "Неуспешно вчитување на статистика.");
}

export async function getInvitationResponses(invitationId) {
  const response = await fetchWithAuth(
    `${API_BASE}/user/invitations/${invitationId}/rsvps`,
    {
      method: "GET",
    }
  );
  return handleJsonResponse(response, "Неуспешно вчитување на RSVP податоци.");
}

export async function deleteInvitation(invitationId) {
  const response = await fetchWithAuth(
    `${API_BASE}/user/invitations/${invitationId}`,
    {
      method: "DELETE",
    }
  );

  if (response && !response.ok) {
    const text = await response.text();
    throw new Error(text || "Неуспешно бришење на поканата.");
  }

  return true;
}
